import React from 'react'
import { Grid } from './Grid'

export function Row (props) {
  const { hide, children, className } = props

  if (hide === true) {
    return null
  }

  return <Grid marginX className={className}>{children}</Grid>
}
